import {VscSettings, VscChromeClose} from 'react-icons/vsc';
import {
  Box,
  Typography,
  useTheme,
  Dialog,
  DialogContent,
  Divider,
  DialogActions,
  DialogTitle,
  styled,
} from '@mui/material';
import type {DialogBoxProps} from '../type';
import Slide from '@mui/material/Slide';
import {TransitionProps} from '@mui/material/transitions';
import {forwardRef, useEffect, useState} from 'react';
import Tabs from '@mui/material/Tabs';
import MuiTab from '@mui/material/Tab';
import SelectList from './selectList';
import {locations, experiences} from '@jobseeker/lotus/components/JobSearchBar/data';

const Tab = styled(MuiTab)(props => ({
  backgroundColor: '#f4f4f4',
  borderBottom: '1px solid #d8d8d8',
  transition: '0.3s ease-out',
  '&.Mui-selected': {
    backgroundColor: '#fff',
  },
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value: string;
  selectedValue: string;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;
  // if (value !== other.selectedValue) {
  //   return <></>;
  // }

  return (
    <Box
      role="tabpanel"
      hidden={value !== other.selectedValue}
      id={`filter-tabpanel-${index || value}`}
      aria-labelledby={`filter-tab-${index || value}`}
      sx={{overflow: 'scroll', width: '100%'}}
      {...other}
    >
      {children}
    </Box>
  );
}
export interface FilterModalProps extends DialogBoxProps {
  onFilterChange: (value: any) => void;
}

const FilterModal = (props: FilterModalProps) => {
  const [value, setValue] = useState('experiance');
  const [formValue, setFormValue] = useState({});
  const theme = useTheme();
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const submitFilter = () => {
    props.onFilter(formValue);
    props.closeDialog();
  };
  useEffect(() => {
    if (props.onChange) {
      props.onFilterChange(formValue);
    }
  }, [formValue]);
  return (
    <Dialog
      fullScreen
      {...props}
      open={!!props.open}
      title="Filter By"
      scroll={'paper'}
      TransitionComponent={Transition}
    >
      <DialogTitle component={'div'}>
        <Box
          sx={{
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Typography
            component={'span'}
            sx={{fontSize: '2rem', lineHeight: 0, cursor: 'pointer'}}
            onClick={props.closeDialog}
          >
            <VscChromeClose />
          </Typography>
          Filter By
        </Box>
      </DialogTitle>
      <DialogContent dividers={true} sx={{p: 0}}>
        <Box
          sx={{
            bgcolor: 'background.paper',
            display: 'flex',
            height: '100%',
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: 'divider',
              height: '100%',
              backgroundColor: '#f4f4f4',
              minWidth: '130px',
            }}
          >
            <Tab disableRipple value={'experiance'} label="Experience" />
            <Tab disableRipple value={'location'} label="Location" />
            <Tab disableRipple value={'posting'} label="Posting" />
          </Tabs>
          <TabPanel value={'experiance'} selectedValue={value}>
            <SelectList
              onChange={(e: any, value: any) =>
                setFormValue({...formValue, experiance: value})
              }
              options={experiences}
            />
          </TabPanel>
          <TabPanel value={'location'} selectedValue={value}>
            <SelectList
              onChange={(e: any, value: any) =>
                setFormValue({...formValue, location: value})
              }
              multiSelect
              options={locations}
            />
          </TabPanel>
          <TabPanel value={'posting'} selectedValue={value}>
            <SelectList
              onChange={(e: any, value: any) =>
                setFormValue({...formValue, posting: value})
              }
              options={[...new Array(10)].map((e, i) => ({
                label: `${5 + i} Years`,
                value: `${5 + i} Years`,
              }))}
            />
          </TabPanel>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
          }}
        >
          <Box
            onClick={props.closeDialog}
            sx={{
              width: '50%',
              textAlign: 'center',
              color: theme.palette.secondary.light,
              cursor: 'pointer',
            }}
          >
            Close
          </Box>
          <Divider orientation="vertical" flexItem />
          <Box
            onClick={submitFilter}
            sx={{
              width: '50%',
              textAlign: 'center',
              color: theme.palette.primary.main,
              cursor: 'pointer',
            }}
          >
            Apply
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

const FilterDialog = (props: any) => {
  const theme = useTheme();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleOpen = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <FilterModal open={dialogOpen} closeDialog={handleClose} {...props} />
      <Box
        onClick={handleOpen}
        sx={{
          p: theme.spacing(1, 2),
          background: '#fff',
          boxShadow: theme.shadows[5],
          width: '120px',
          borderRadius: '10px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          color: theme.palette.secondary.main,
          gap: '8px',
          border: `0.5px solid ${theme.palette.gray.main}`,
          cursor: 'pointer',
        }}
      >
        <Typography component={'span'} className="">
          Filter
        </Typography>
        <Box sx={{fontSize: '1.2rem'}}>
          <VscSettings />
        </Box>
      </Box>
    </>
  );
};

export default FilterDialog;
